<div class="row" *ngIf="listInput.isView">
  <div class="col">
    <div class="card">
      <div class="card-header transparent">
        <label> Company Information </label>
        <button class="btn btn-sm text_right" (click)="CreateorUpdateList('new')" data-bs-toggle="modal" *ngIf="fp.companycreate"
          data-bs-target="#companyEdit">
          New Company
        </button>
      </div>
      <div class="card-header transparent">
        <div class="row d-flex justify-content-between align-items-center">
          <div class="col-lg-6 col-sm-6 col-md-6 col-xs-12">
            <label class="label col-lg-5">Status</label>
            <ng-select class="w-50" [(ngModel)]="ListCompanyBO.statusLid" (change)="getCompanyList()"
              [clearable]="false" [searchable]="true" [items]="CompanyStatusList" bindLabel="lovName" bindValue="id">
            </ng-select>
          </div>
          <div class="col-lg-6">
            <button class="btn btn-sm float-end" (click)="refresh()">
              <i class="fa fa-repeat"> </i> Refresh
            </button>
          </div>
        </div>
      </div>
      <div class="card-body">
        <ejs-grid #grid [dataSource]="companyData | async" [allowPaging]="true"
          (dataStateChange)="dataChangeCompany($event)" (actionBegin)="onActionCompany($event)" [showColumnChooser]='true'
          [pageSettings]="initialPage" [filterSettings]="filterSettings" [allowFiltering]="true" [allowResizing]="true">
          <e-columns>
            <e-column headerText="Action" uid="action" textAlign="center" minWidth="100" [showInColumnChooser]="false">
              <ng-template #template let-data>
                <button class="btn btn-edit-table text-center" data-bs-toggle="modal" data-bs-target="#companyEdit"
                  (click)="CreateorUpdateList('edit'); getCompanyDetails(data)"  *ngIf="fp.companyupdate">
                  <i class="fa fa-edit"></i>
                </button>
              </ng-template>
            </e-column>
            <e-column field="name" minWidth="100" headerText="Company Name" type="string">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
            <e-column field="fein" minWidth="100" headerText="Company FEIN Number" type="string">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
            <e-column field="adminFullName" minWidth="140" headerText="Admin Full Name" type="string">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
            <e-column field="street" minWidth="100" headerText="Street" type="string">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
            <e-column field="city" minWidth="100" headerText="City" type="string">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
            <e-column field="state" minWidth="100" headerText="State" type="string">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
            <e-column field="zipCode" minWidth="100" headerText="Zip Code" type="string">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
            <e-column field="phoneNumber" minWidth="100" headerText="Mobile Number" type="string">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
            <e-column field="fax" minWidth="100" headerText="fax" type="string"  [template]="faxNumberTemplate">
              <!-- <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template> -->
              <ng-template #faxNumberTemplate let-data>
                {{ data.fax | usNumberFormat }}
            </ng-template>
            </e-column>

            <e-column field="statusName" minWidth="100" headerText="Status" type="string">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>

            <!--------------------------------table header icon---------------->
            <e-column width="50" [showInColumnChooser]="false">
              <ng-template #headerTemplate let-data>
                <div>
                  <span id="show" (click)="show()"><i class="fa fa-cog fa-lg" aria-hidden="true"> </i></span>
                </div>
              </ng-template>
            </e-column>
          </e-columns>
        </ejs-grid>
      </div>
      <div class="card-footer transparent">
        <button class="btn btn-sm text_right transparent" data-bs-dismiss="modal" (click)="dataEmitAgency()">
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<span id="EditCompany" data-bs-target="#companyEdit" data-bs-toggle="modal"></span>
<div class="modal fade modalbackgrod" id="companyEdit" aria-hidden="true" data-bs-backdrop="false">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="exampleModalLabel">
          <span *ngIf="modalType == 'new'"><b> Create Company</b></span>
          <span *ngIf="modalType == 'edit'"><b>Update Company</b></span>
        </h1>

        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="reset()"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="companyFormGroup">
          <label class="font-header ml-1">Company info</label>
          <hr class="mt-0" />
          <div class="row">
            <div class="col-lg-4 col-sm-6 col-md-6 col-xs-12">
              <label class="label col-lg-5">Status<sup class="super-script">&nbsp;*&nbsp;</sup></label>
              <ng-select class="w-70" [(ngModel)]="Company.statusLid" formControlName="Status" [clearable]="false"
                [searchable]="true" [items]="statusList" bindLabel="Value" bindValue="Key">
              </ng-select>
              <span *ngIf="Status.touched && Status.invalid" class="req">Status field is required
              </span>
            </div>
            <div class="col-lg-4 col-sm-6 col-md-6 col-xs-12">
              <label class="label col">Company Name<sup class="super-script">&nbsp;*&nbsp;</sup></label>
              <input type="text" class="form-control width100 col-lg-5 lablestyle" [(ngModel)]="Company.name"
                formControlName="Companyname" />
              <span *ngIf="Companyname.touched && Companyname.invalid" class="req">Company Name is required
              </span>
            </div>
            <div class="col-lg-4 col-sm-6 col-md-6 col-xs-12">
              <label class="label col-lg-7">Company FEIN Number<sup class="super-script">&nbsp;*&nbsp;</sup></label>
              <input type="text" class="form-control width100 col-lg-5" formControlName="fein" maxlength="9"
                [(ngModel)]="Company.fEIN" />
                <span *ngIf="fein.touched && fein.invalid" class="req">Company FEIN Number is required
                </span>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4 col-sm-6 col-md-6 col-xs-12">
              <label class="label col-lg-6">Admin Full Name<sup class="super-script">&nbsp;*&nbsp;</sup></label>

              <input type="text" class="form-control width100 col-lg-7" [(ngModel)]="Company.adminFullName"
                formControlName="fullName" />
              <span *ngIf="fullName.touched && fullName.invalid" class="req">Admin Name is required
              </span>
            </div>
            <div class="col-lg-4 col-sm-6 col-md-6 col-xs-12">
              <label class="label col-lg-5">Street</label>

              <input type="text" class="form-control width100 col-lg-7" formControlName="street"
                [(ngModel)]="Company.street" />
            </div>
            <div class="col-lg-4 col-sm-6 col-md-6 col-xs-12">
              <label class="label col-lg-5">City</label>

              <input type="text" class="form-control width100 col-lg-7" formControlName="city"
                [(ngModel)]="Company.city" />
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4 col-sm-6 col-md-6 col-xs-12">
              <label class="label col-lg-5">State</label>

              <ng-select [searchable]="true" [clearable]="true" bindLabel="name" [items]="stateList"
                formControlName="state" bindValue="abbreviation" [(ngModel)]="Company.state">
              </ng-select>
            </div>
            <div class="col-lg-4 col-sm-6 col-md-6 col-xs-12">
              <label class="label col-lg-5">Zip Code</label>

              <input type="text" class="form-control width100 col-lg-5" formControlName="zipcode"
                [(ngModel)]="Company.zipCode" minlength="5" maxlength="11" (keypress)="keyPress($event)" />
            </div>
            <div class="col-lg-4 col-sm-6 col-md-6 col-xs-12">
              <label class="label col-lg-5">Phone</label>

              <input type="text" class="form-control width100 col-lg-5" formControlName="phone"
                [(ngModel)]="Company.phoneNumber" (keypress)="keyPress($event)" minlength="14" maxlength="14"
                (ngModelChange)="DemographicPhoneFormat()" />
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4 col-sm-6 col-md-6 col-xs-12">
              <label class="label col-lg-5">Fax</label>

              <input type="text" class="form-control width100 col-lg-7" formControlName="fax" [(ngModel)]="Company.fax"
                (keypress)="keyPress($event)" minlength="14" maxlength="14"
                (ngModelChange)="DemographicPhoneFormat()" />
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button class="btn btn-sm p-2 text_right" (click)="saveCompany()" [disabled]="!companyFormGroup.valid"
         >
          <span *ngIf="modalType == 'new'"> Save & close </span>
          <span *ngIf="modalType == 'edit'">Update & close </span>
        </button>
      </div>
    </div>
  </div>
</div>